import { useQuery } from "@tanstack/react-query";
import DuplicateLeadApi from "../api/DuplicateLeadApi";

export const useDuplicateLeadsData = ({
  page,
  limit,
  ofCompany,
  queryString = "",
  queryParams = "",
  sort = "-createdTime",
}) => {
  const { data, isLoading, isError, error, isFetching } = useQuery({
    queryKey: [
      "duplicateLeads",
      page,
      limit,
      ofCompany,
      queryParams,
      queryString,
      sort,
    ], // Ensure `page` is part of the key
    queryFn: () =>
      DuplicateLeadApi.fetchDuplicateLeads({
        page,
        limit,
        ofCompany,
        queryString,
        queryParams,
        populate: "ofCompany,assignedTo",
        selectPopulate: "name",
        sort,
      }),
    keepPreviousData: true, // Retain previous data during fetching
    staleTime: Infinity, // Cache duration
  });

  return { data, isLoading, isError, error, isFetching };
};
